import { render, staticRenderFns } from "./TableCategory.vue?vue&type=template&id=5ab06cd5"
import script from "./TableCategory.vue?vue&type=script&lang=js"
export * from "./TableCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports